// A Zernio "account key" labels WHICH connected aggregator account a channel
// belongs to, so credentials (API key + webhook secret) resolve per account
// rather than per provider. `default` = the original account (Instagram +
// TikTok); `brand2` = the second brand's account (YouTube + X). Each Zernio
// account here maps to its own `SOCIAL_ZERNIO_API_KEY*` + webhook secret env
// pair (see `env/social.ts`). Single source for the union; the D1
// `social_channel.account_key` / `social_post.account_key` inline enums are
// pinned to it by `social-enums.test.ts`.
export const SOCIAL_ACCOUNT_KEYS = ['default', 'brand2'] as const;

export type SocialAccountKeyType = (typeof SOCIAL_ACCOUNT_KEYS)[number];

export const DEFAULT_SOCIAL_ACCOUNT_KEY: SocialAccountKeyType = 'default';
